import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { Card, IconButton, Tooltip } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiSelect from "components/SuiSelect";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Prompt from "components/UpStyled/Prompt";
import CounterContext from "context/counter";
import { nanoid } from "nanoid";
import { useContext, useEffect, useState, useImperativeHandle, forwardRef } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import api from "services/api";
import { Empty } from "antd";

const smartdate = require("smartdate");
smartdate.init();

const NotificationCard = forwardRef(({ height = null, width = "500px", sx = {} }, ref) => {
  const msgcounter = useContext(CounterContext);
  const [notifications, setNotifications] = useState([]);
  const [selectedType, setSelectedType] = useState({ value: "all", label: "All types" });

  useImperativeHandle(
    ref,
    () => ({
      notifications,
      setNotifications,
      refresh,
    }),
    [notifications]
  );

  const refresh = () => {
    try {
      api.notifications.list().then(({ data }) => {
        setNotifications(data.notifications);
        return data;
      });
    } catch (err) {
      toast.error(`notifications list!`);
      console.log(err);
    }
    msgcounter.getNewMessageCount();
  };

  useEffect(() => {
    refresh();
  }, []);

  const update = (payload) => {
    try {
      api.notifications.update(payload).then(({ data }) => {
        refresh();
        return data;
      });
    } catch (err) {
      toast.error(`notifications list!`);
      console.log(err);
    }
  };

  var selectednotifications = notifications.filter(
    (n) => selectedType.value == "all" || n.type === selectedType.value
  );
  const renderProfiles = selectednotifications.map((notification, index) => (
    <SuiBox
      component={notification.target != "#" ? Link : "div"}
      to={notification.target}
      target="_blank"
      style={{ color: "inherit", cursor: "pointer" }}
      onClick={(e) => {
        //update({ delete: [notification.id] });
      }}
    >
      <SuiBox
        key={index}
        component="li"
        display="flex"
        alignItems="center"
        py={1}
        sx={{ cursor: "pointer" }}
      >
        <SuiBox mr={1}>
          <ContactAvatar contact={notification} size="sm" />
        </SuiBox>
        <SuiBox className="w-full ml-0.5">
          <SuiBox className="flex justify-between items-center">
            <SuiBox className="flex items-center">
              <SuiTypography variant="button" fontWeight="medium">
                {notification.type +
                  (["Admin Notice", "event", "reminder"].includes(notification.type)
                    ? ""
                    : " from " + notification.username)}
              </SuiTypography>
            </SuiBox>
            <SuiBox className="flex items-center">
              <div>
                <SuiTypography variant="caption">
                  {smartdate.format(new Date(notification.timestamp))}
                </SuiTypography>
              </div>
              <div>
                <Tooltip title="Clear notification" placement="top">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      update({ delete: [notification.id] });
                    }}
                    sx={{ p: 0, m: 0, width: "26.25px", height: "26.25px" }}
                    className="hover:bg-gray-300"
                  >
                    <DeleteIcon sx={{ p: 0, m: 0, width: "26.25px", height: "26.25px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </SuiBox>
          </SuiBox>
          <div className="flex justify-between">
            <SuiTypography
              variant="caption"
              textTransform="none"
              sx={{
                width: "100%",
                minHeight: "28px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
              }}
            >
              {notification.descr}
            </SuiTypography>
          </div>
        </SuiBox>
      </SuiBox>
    </SuiBox>
  ));

  //console.log('contactlist', contactlist)
  return (
    <Card sx={{ height: "100%", width: "100%", overflow: "auto", ...sx }}>
      <SuiBox pt={1} px={2}>
        <SuiTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
          sx={{ px: 1, mt: 1 }}
        >
          {"Notifications"}
        </SuiTypography>
      </SuiBox>

      <SuiBox p={1} sx={{ overflowY: "auto" }}>
        <SuiBox component="ul" display="flex" flexDirection="column" px={2} m={0}>
          {selectednotifications.length > 0 ? renderProfiles : <Empty />}
        </SuiBox>
      </SuiBox>
    </Card>
  );
});

export default NotificationCard;
